import { ListItemText, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import React, { useState } from "react";
import { ISouscripteur } from "../../store/focusEcoleSlice";
import { useSelector } from "react-redux";
import { IReduxState } from "../../store";
import TablePagination from "@mui/material/TablePagination";

const Liste = () => {
  const filteredSouscripteurs = useSelector((state: IReduxState) => state.focusEcole.filteredSouscripteurs);

  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Items per page

  // Handle page change
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // Handle change in items per page
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Calculate the items to display on the current page
  const paginatedSouscripteurs = filteredSouscripteurs?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <div
        style={{
          padding: 10,
          height: "40vh",
          overflow: "auto",
          marginTop: 10,
        }}
      >
        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <List dense={true}>
            {paginatedSouscripteurs?.map((item: ISouscripteur, i: number) => (
              <div key={i}>
                <ListItem>
                  <ListItemButton>
                    <ListItemText
                      primary={`${item?.nomPrenomParent} - ${item?.numeroCellulaire || ""}`}
                      secondary={
                        <Box style={{ display: "flex", flexDirection: "column" }}>
                          <Typography variant="caption">{`${item?.filiation}`}</Typography>
                          <Typography variant="caption">{`${item?.codeEtab} - ${item?.anneeScolaire}`}</Typography>
                          <Typography variant="caption">{`${item?.idEleve}`}</Typography>
                        </Box>
                      }
                    />
                  </ListItemButton>
                </ListItem>
                <Divider />
              </div>
            ))}
          </List>
          <TablePagination
            component="div"
            count={filteredSouscripteurs?.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </div>
    </>
  );
};

export default Liste;
